/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Mock_TitleInputs */

const en_st_mock_title = /** @type {(inputs: St_Mock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What your client sees`)
};

const id_st_mock_title = /** @type {(inputs: St_Mock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yang klien kamu lihat`)
};

/**
* | output |
* | --- |
* | "What your client sees" |
*
* @param {St_Mock_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_mock_title = /** @type {((inputs?: St_Mock_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Mock_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_mock_title(inputs)
	return en_st_mock_title(inputs)
});